// src/hooks/usePageContent.js
import { useState } from "react";
import {
  updatePassword,
} from "../services/profileService";

const useChangePassword = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");

  const changePassword = async (reqChangePassword) => {
    setStatus("loading");
    setError("");
    // cart item
    // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "applicationUserId": "string",
    // "qty": 0
    try {
      const response = await updatePassword(reqChangePassword);

      if (response?.status !== "Error") {
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    changePassword,
    status,
    error,
    resetStatus,
  };
};

export default useChangePassword;